document.addEventListener('click', function(e) {
  const button = e.target.closest('.quantity.cart-update .minus');
  if (button) {
    const input = button.closest('.quantity').querySelector('.qty');
    if (input && parseInt(input.value) <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const cartUpdate = button.closest('.cart-update');
      const index = input.dataset.index;
      const item = button.closest('.product-cart-item');
      if (item) item.classList.add('thb-loading');

      const body = JSON.stringify({
        line: index,
        quantity: 0,
        sections: ['cart-drawer', 'cart-bubble'],
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body
      })
      .then(res => res.json())
      .then(parsedState => {
        if (parsedState.sections) {
          const drawerEl = document.getElementById('Cart-Drawer');
          if (drawerEl && parsedState.sections['cart-drawer']) {
            const parsed = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            const newInner = parsed.querySelector('#Cart-Drawer');
            if (newInner) {
              drawerEl.innerHTML = newInner.innerHTML;
            }
          }
        }
      });
    }
  }
}, true);

// ============================================
// HEADER COLOUR ON NAV HOVER — DESKTOP ONLY
// ============================================
(function() {
  if (window.innerWidth < 1068) return;

  var icePink = getComputedStyle(document.documentElement).getPropertyValue('--reverie-ice-pink').trim();
  var darkCherry = getComputedStyle(document.documentElement).getPropertyValue('--reverie-dark-cherry').trim();

  var header = document.querySelector('.header');
  var headerRow = document.querySelector('theme-header .row.expanded');
  var themeHeader = document.querySelector('theme-header');

  function setColour(colour) {
    if (header) header.style.background = colour;
    if (headerRow) headerRow.style.background = colour;
    if (themeHeader) themeHeader.style.background = colour;
  }

  if (themeHeader) {
    themeHeader.addEventListener('mouseenter', function() { setColour(darkCherry); });
    themeHeader.addEventListener('mouseleave', function() { setColour(''); });
  }

  var megaItems = document.querySelectorAll('.menu-item-has-megamenu');
  megaItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() { setColour(icePink); });
    item.addEventListener('mouseleave', function() { setColour(darkCherry); });
  });
})();

// ============================================
// MEGA MENU — LAZYLOAD + PROMO IMAGE INJECT
// ============================================
function injectPromoImages() {
  var promos = document.querySelectorAll('.mega-menu-container--promotions .mega-menu-promotions a.mega-menu-promotion');
  var cards = document.querySelectorAll('.mega-menu-container--promotions ul.mega-menu-columns > li');

  if (!promos.length || !cards.length) return;

  [0, 1].forEach(function(i) {
    var img = promos[i] ? promos[i].querySelector('img') : null;
    if (!img || !cards[i]) return;

    // Force lazyload first
    if (img.dataset.src) img.src = img.dataset.src;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;

    // Use best available src
    var src = (img.currentSrc && img.currentSrc !== '') ? img.currentSrc
            : (img.src && !img.src.endsWith('undefined')) ? img.src
            : img.dataset.src || '';

    if (src) {
      cards[i].style.backgroundImage = 'url(' + src + ')';
      cards[i].style.backgroundSize = 'cover';
      cards[i].style.backgroundPosition = 'center';
    }

    // If image not yet loaded, wait for it then re-inject
    if (!img.complete) {
      img.addEventListener('load', function() {
        var loaded = img.currentSrc || img.src;
        if (loaded) {
          cards[i].style.backgroundImage = 'url(' + loaded + ')';
        }
      }, { once: true });
    }
  });
}

document.querySelectorAll('.menu-item-has-megamenu').forEach(function(item) {
  item.addEventListener('mouseenter', function() {
    setTimeout(injectPromoImages, 100);
  });
});
// ============================================
// REMOVE NAV SVG ARROWS — GUARANTEED
// ============================================
function removeNavArrows() {
  document.querySelectorAll('a.thb-full-menu--link svg').forEach(function(svg) {
    svg.style.display = 'none';
  });
}

removeNavArrows();
document.addEventListener('DOMContentLoaded', removeNavArrows);

// ============================================
// MOBILE NAV — NEW IN: button → direct navigate
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  var newInBtn = document.querySelector(
    '.mobile-menu-drawer button.parent-link-trigger[data-submenu="submenu-1"]'
  );
  if (newInBtn) {
    newInBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = '/collections/new-in';
    }, true);
  }
});

/* ── DESKTOP SEARCH INTERCEPT ── */
(function() {
  function initDesktopSearch() {
    var trigger = document.querySelector('a.thb-quick-search, a.thb-secondary-area-item.thb-quick-search');
    var desktopBar = document.getElementById('desktop-search-bar');
    var desktopInput = document.getElementById('desktop-search-input');

    if (!trigger || !desktopBar) return;

    trigger.addEventListener('click', function(e) {
      if (window.innerWidth < 768) return; // let mobile handle it
      e.preventDefault();
      e.stopImmediatePropagation();

      var nativeDrawer = document.getElementById('Search-Drawer');
      if (nativeDrawer) nativeDrawer.classList.remove('active');

      if (desktopBar.classList.contains('active')) {
        desktopBar.classList.remove('active');
        document.body.classList.remove('desktop-search-open');
        if (desktopInput) desktopInput.value = '';
      } else {
        desktopBar.classList.add('active');
        document.body.classList.add('desktop-search-open');
        setTimeout(function() { if (desktopInput) desktopInput.focus(); }, 350);
      }
    }, true); // capture phase — fires before app.js
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopSearch);
  } else {
    initDesktopSearch();
  }
})();
